import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_INDUSTRY: (industryId, industry, industryCpdCategory) => ({ industryId, industry, industryCpdCategory }),
    API: {
      UPDATE_INDUSTRY: apiResourceActionCreator('industry')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.put(`${API_ENDPOINT}/update-industry/${payload.industryId}`, authToken, payload, actions.admin.api.updateIndustry);

function* updateIndustry(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.admin.api.updateIndustry);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.industry }));
  }
}

const configuration = {
  name: 'updateIndustry',
  action: actions,
  sagas: updateIndustry,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateIndustry.js